import { render, staticRenderFns } from "./ZjdfmxForm.vue?vue&type=template&id=65edd425&scoped=true"
import script from "./ZjdfmxForm.vue?vue&type=script&lang=js"
export * from "./ZjdfmxForm.vue?vue&type=script&lang=js"
import style0 from "./ZjdfmxForm.vue?vue&type=style&index=0&id=65edd425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65edd425",
  null
  
)

export default component.exports